"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _func = require("../utils/func");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = (0, _func.curry)(function (defaultDelay, Origin) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_PureComponent) {
    _inheritsLoose(_class, _PureComponent);

    function _class(props) {
      var _this;

      _this = _PureComponent.call(this, props) || this;
      _this.state = {
        value: props.value
      };
      _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.forceChange = _this.forceChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      return _this;
    }

    var _proto = _class.prototype;

    _proto.getValue = function getValue() {
      if (this.changeLocked) return this.state.value;
      return this.props.value;
    };

    _proto.handleChange = function handleChange(value) {
      var _this2 = this;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var delay = this.props.delay;

      if (delay === 0) {
        var _this$props;

        (_this$props = this.props).onChange.apply(_this$props, [value].concat(args));

        return;
      }

      this.setState({
        value: value
      });
      this.changeLocked = true;
      if (this.changeTimer) clearTimeout(this.changeTimer);
      this.changeTimer = setTimeout(function () {
        var _this2$props;

        _this2.changeLocked = false;

        (_this2$props = _this2.props).onChange.apply(_this2$props, [value].concat(args));
      }, delay);
    };

    _proto.forceChange = function forceChange(value) {
      var _this$props2;

      this.setState({
        value: value
      });

      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      (_this$props2 = this.props).onChange.apply(_this$props2, [value].concat(args));

      this.changeLocked = false;
    };

    _proto.render = function render() {
      var _this$props3 = this.props,
          value = _this$props3.value,
          onChange = _this$props3.onChange,
          props = _objectWithoutPropertiesLoose(_this$props3, ["value", "onChange"]);

      return _react.default.createElement(Origin, _extends({}, props, {
        value: this.getValue(),
        onChange: this.handleChange,
        forceChange: this.forceChange
      }));
    };

    return _class;
  }(_react.PureComponent), _defineProperty(_class, "propTypes", {
    delay: _propTypes.default.number,
    onChange: _propTypes.default.func.isRequired,
    value: _propTypes.default.any
  }), _defineProperty(_class, "defaultProps", {
    delay: defaultDelay
  }), _temp;
});

exports.default = _default;